import React from 'react';
import { Box, Typography } from '@mui/material';

const ProductImage = ({ 
  imageUrl, 
  productName, 
  size = 60, 
  borderRadius = 1,
  showFallback = true 
}) => {
  const [imageError, setImageError] = React.useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <Box
      sx={{
        minWidth: size,
        height: size,
        borderRadius,
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {imageUrl && !imageError ? (
        <img
          src={imageUrl.startsWith('http') ? imageUrl : `${'https://api.inklandtattoo.fr'}${imageUrl}`}
          alt={productName || 'Produit'}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          onError={handleImageError}
        />
      ) : showFallback ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            color: 'text.secondary',
            fontSize: '0.75rem',
            textAlign: 'center',
            flexDirection: 'column',
            gap: 0.5,
          }}
        >
          <Typography 
            variant="caption" 
            sx={{ 
              fontSize: '0.6rem',
              fontWeight: 500,
              textTransform: 'uppercase',
            }}
          >
            {productName?.charAt(0) || 'N/A'}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};

export default ProductImage;



